import React, {useContext, useEffect, useRef, useState} from 'react';
import {useRouter} from "next/router";
import styled from "styled-components";
import AppLayout from "@layouts/app.layout";
import {UserContext, UserDispatcherContext} from "@providers/user";
import Navbar from "@organisms/navbar/navbar";
import ContactInfoModal from "@organisms/contact_info/contact_modal";
import SearchTabs from "@organisms/property/components/search.sorts";
import {checkUserModality} from "@organisms/property/helpers/property_helpers";
import {
    getSearchHotLinks,
    generateSearchTitle,
    handleLandingsDataSsr,
    getCanonicalSearchWidget,
    getCitiesItemsFilterOptions,
    checkCanonicalLink
} from "@organisms/property/helpers/search_helper";
import {getProperties} from "@models/search";
import {PropertiesContext, PropertiesDispatcherContext} from "@providers/properties";
import {FilterContext, FilterDispatcherContext} from "@providers/filters";
import usePrevious from "@hooks/previous";
import {isEmpty} from "@helpers/helpers";
import {setDefaultCity} from "@models/district";
import {
    getUrlParams,
    removeURLParameter,
    scrollToOffsetTop,
    scrollToTop,
    str_replace
} from "../../components/helpers/helpers";
import {checkFiltersForRedirect, getSearchLink, mergeFiltersParams} from "../../models/search";
import {
    getBookmarkProperties,
    getPropertyDealTypesByCityId,
    getPropertyTypesByCityId,
    getUserProperties
} from "../../models/property";
import {object_unique, ObjectLength} from "../../components/helpers/arrays";
import {pluckKeyToArray} from "@hooks/selection.options";
import {getDefaultCity} from "@hooks/cities";
import {getWidgets, getWidgetSearchParams} from "@models/widget";
import {getCity} from "@models/district";
import {checkUrlParams, linkTypes} from "@models/check_link";
import BreadcrumbListSchema from "../../components/molecules/schema/breadcrumb_list_schema";
import PropertiesSchema from "../../components/molecules/schema/properties";
import {Redirect} from "../../components/helpers/redirect";
import {getCityURL, getDistricts} from "../../models/district";
import SearchPropertyCard from "../../components/organisms/search/property_card";
import SearchFiltersAndModalFilters from '../../components/organisms/search/search_filters_and_modal_filters';
import ShowSearchLandings from "../../components/organisms/search/show_landings";
import SearchPageTitle from "../../components/organisms/search/page_title";
import SearchNoResults from "../../components/organisms/search/search_no_results";
import {handleFooterLinks} from "@organisms/footer/helpers";
import {handleNavbarLinks} from "@organisms/navbar/helpers";
import {
    checkGridView,
    handlePageRobots,
    showHayaatBanner
} from "../../components/organisms/property/helpers/property_helpers";
import {useWindowSize} from "../../components/helpers/windows.size";
import {checkRunInvestmentConversionsPopUp} from "@organisms/property/invest/convertion_helper";
import InvestmentBannerGridWithLottie from "@molecules/banners/investment_banner_grid_with_lottie";
import "@assets/scss/swiper/swiper.scss";
import 'react-perfect-scrollbar/dist/css/styles.css';
import SearchFaqs from "../../components/organisms/search/search_faqs";
import {getSearchBrandingText, getSearchFaq} from "../../components/organisms/property/helpers/search_helper";
import FaqSchema from "../../components/molecules/schema/faq/faq_schema";
import BrandingText from "../../components/molecules/widgets/branding_text";

var getPropertiesTimeOut = undefined;

function Properties({
                        footerLinks,
                        navbarLinks,
                        urlParams,
                        ssrProperties,
                        ssrHotLinks,
                        ssrFaqsList,
                        ssrBrandingText,
                        isBadeSaba,
                        searchWidget,
                        landingData,
                        pageRobots,
                        pageTitles,
                        pageCanonicalLink,
                        redirectToLanding,
                        isServerSide = false,
                        ssrFilterOptionsByCity
                    }) {
    const windowSize = useWindowSize();
    const router = useRouter();
    const searchNavbarRef = useRef('');
    const cardRef = useRef('');
    const [title, setTitle] = useState(pageTitles ?? '');
    const [categories, setCategories] = useState('search');
    const [showLanding, setShowLanding] = useState((!isEmpty(redirectToLanding) ? redirectToLanding.landing : ''));
    const [login, setLogin] = useState({show: false, callback: undefined});

    const [forceShowNoResult, setForceShowNoResult] = useState(false);
    const [skeleton, setSkeleton] = useState(false);
    const [loadServerSide, setLoadServerSide] = useState(isServerSide);
    const [contactInfo, setContactInfo] = useState({
        show: false,
        property_id: null,
        realtor_id: null,
        agency_id: null,
        isAssignedProperty: false,
        isOnList: true,
        exists_in_kanban: false,
        isBadeSaba: false,
    });

    const userContext = React.useContext(UserContext);
    const userDispatcherContext = React.useContext(UserDispatcherContext);
    const properties_context = useContext(PropertiesContext);
    const properties_dispatcher = useContext(PropertiesDispatcherContext);
    const filters = useContext(FilterContext);
    const filterDispatcher = React.useContext(FilterDispatcherContext);

    const properties = (!process.browser && !isEmpty(ssrProperties) && !isEmpty(ssrProperties.properties)) ? ssrProperties.properties : ((!isEmpty(properties_context) && !isEmpty(properties_context.properties)) ? properties_context.properties : []);

    const selectedCity = getCity(!isEmpty(filters.selected_filters) ? filters.selected_filters.city_id : (!isEmpty(urlParams['city_id']) ? urlParams['city_id'] : getDefaultCity()));


    let selectedFilters = JSON.stringify(filters.selected_filters);
    let prevSelectedFilters = usePrevious(selectedFilters, (!loadServerSide && !filters.waiting.city && !filters.waiting.district && !filters.waiting.deal_type && !filters.waiting.types));

    const selectedFiltersDistrictIds = !isEmpty(urlParams['district_id']) ? urlParams['district_id'] : pluckKeyToArray(filters.selected_filters.district_id, 'value');

    const handleLoginWithCallback = (show, callable = undefined) => {
        setLogin({
            show: show,
            callback: callable
        })
    };

    const handleTitle = (searchLandingTitles = null) => {
        generateSearchTitle(filters.selected_filters, window.location.pathname).then(result => {
            if (!isEmpty(searchLandingTitles)) {
                result.main = searchWidget.widget.caption;

                if (!isEmpty(searchWidget.widget.title)) {
                    result.pageTitle = searchWidget.widget.title;
                }

                if (!isEmpty(searchWidget.widget.label)) {
                    result.pageDescription = searchWidget.widget.label;
                }
            }

            setTitle(result);
        })
    };

    const handleGetProperties = async (type = 'ADD_NEW', reset_page = false, show_skeleton = true, search_landing = false, load_more) => {

        if (!skeleton && show_skeleton) {
            setSkeleton(true);
        }

        if (process.browser && type === 'ADD_NEW') {
            scrollToTop();
        }

        const {last_route} = properties_context;

        let page = reset_page ? 1 : ((!isEmpty(load_more) && load_more.page) ? load_more.page : 1);

        let $params = JSON.parse(JSON.stringify(filters.selected_filters)); // deep copy
        $params['district_id'] = pluckKeyToArray($params['district_id'], 'value');

        if (type === 'ADD_NEW' && !search_landing) {
            if (isBadeSaba) {
                $params['badesaba'] = true;
            }

            getSearchLink($params).then(result => {
                const location = document.location;
                const path = location.pathname + location.search;

                if (decodeURI(result.url) !== decodeURI(path)) {
                    router.push('/properties', result.url, {shallow: true});
                }
            });

            handleTitle();
        }

        delete $params['badesaba']; // remove extra params
        $params['exclude_archived'] = 1;

        await getProperties(page, last_route, $params, true).then(result => {

            if (result && isEmpty(result.loading) || !result.loading) {

                if (isEmpty(result.duplicate) || !result.duplicate) {
                    properties_dispatcher({
                        type: type,
                        payload: result,
                        page: page + 1
                    });
                }

                setSkeleton(false);
            } else if (type === 'ADD_NEW') {
                setSkeleton(true);
            }
        });

        return true;
    };

    const getCitiesItems = async (params) => {

        if (!isEmpty(ssrFilterOptionsByCity)) {
            await filterDispatcher({
                type: 'CITIES_OPTIONS',
                payload: ssrFilterOptionsByCity
            });

            if (process.browser && !isEmpty(selectedCity)) { // update localStorage city data when
                await getDistricts(selectedCity.id);
                await getPropertyDealTypesByCityId(selectedCity.id);
                await getPropertyTypesByCityId(selectedCity.id);
            }

            ssrFilterOptionsByCity = undefined;
        } else {
            const filterOptionsByCity = await getCitiesItemsFilterOptions(params, isBadeSaba);

            await filterDispatcher({
                type: 'CITIES_OPTIONS',
                payload: filterOptionsByCity
            });
        }
    };

    var getUserPropertiesRequest = true;
    const handleUserProperties = () => {
        if (categories !== 'my_properties') {
            setCategories('my_properties');

            if (getUserPropertiesRequest) {
                getUserPropertiesRequest = false;

                getUserProperties().then(result => {
                    getUserPropertiesRequest = true;

                    properties_dispatcher({
                        type: 'ADD_NEW',
                        payload: result,
                        page: 2,
                        list_page: 'my_properties'
                    });

                    setSkeleton(false);
                    setLoadServerSide(false);

                    document.body.click()
                }).catch(err => {
                    getUserPropertiesRequest = true;
                    setCategories('search');
                    setSkeleton(false);

                    if (!properties.length) {
                        handleGetProperties('ADD_NEW', true);
                    }
                })
            }
        } else {
            setSkeleton(false);
        }
    };

    var getBookmarks = true;
    const handleBookmarkProperties = () => {
        if (categories !== 'follow') {
            setCategories('follow');

            if (getBookmarks) {
                getBookmarks = false;

                getBookmarkProperties().then(result => {
                    getBookmarks = true;

                    properties_dispatcher({
                        type: 'ADD_NEW',
                        payload: result,
                        page: 2,
                        list_page: 'follow'
                    });

                    setSkeleton(false);
                    setLoadServerSide(false);
                }).catch(err => {
                    getBookmarks = true;
                    setCategories('search');
                    setSkeleton(false);

                    if (!properties.length) {
                        handleGetProperties('ADD_NEW', true);
                    }
                })
            }
        } else {
            setSkeleton(false);
        }
    };

    const getParamsFromLocationPath = () => {
        const location = document.location;

        const path = location.pathname + location.search;
        setSkeleton(true);
        setShowLanding('');

        const pathDecode = decodeURI(path);
        const hasAmlak = pathDecode.indexOf('املاک-');

        if (hasAmlak !== -1) {

            checkUrlParams(path, linkTypes.SEARCH).then(result => {
                urlParams = object_unique(mergeFiltersParams(result.query));

                urlParams = object_unique(mergeFiltersParams(urlParams));
                handlePageWithUrlParams();
            }).catch(err => {
                console.log(err);
                setSkeleton(false);
            });
        } else {
            const params = getUrlParams(path);

            urlParams = object_unique(mergeFiltersParams(params));
            handlePageWithUrlParams();
        }
    };

    var setLoadServerSideTimeOut = undefined;
    const handlePageWithUrlParams = () => {
        const asUrl = (process.browser && window.history && window.history.state) ? window.history.state.as : '';
        const bodyClassList = document.body.classList;
        const checkBodyClassLists = (!bodyClassList.contains('filter-open') && !bodyClassList.contains('selection-open') && !bodyClassList.contains('modal-open'));
        const routerQuery = router.query;
        const checkIsCategoryParam = (!isEmpty(routerQuery) && typeof routerQuery === "object" && ObjectLength(routerQuery) && !isEmpty(routerQuery.category));

        if (checkBodyClassLists && (!isEmpty(urlParams['categories[my_properties]']) || asUrl === '/properties?categories[my_properties]=on')) {
            prevSelectedFilters = 'categories[my_properties]';
            handleUserProperties();
        } else if (checkBodyClassLists && (!isEmpty(urlParams['follow']) || asUrl === '/properties?follow=1')) {
            prevSelectedFilters = 'categories[follow]';
            handleBookmarkProperties();
        } else if (!checkIsCategoryParam) {
            setCategories('search');

            if (!isEmpty(ssrProperties)) {
                properties_dispatcher({
                    type: 'ADD_NEW',
                    payload: ssrProperties,
                    page: 2
                });

                setSkeleton(false);
            }

            if (!isEmpty(urlParams['checkRedirectToLanding']) && urlParams['checkRedirectToLanding'].redirect) {
                setShowLanding(urlParams['checkRedirectToLanding'].landing)
            }

            let filterUrlParams = object_unique(urlParams);

            filterUrlParams['waiting'] = {
                city: true,
                district: true,
                deal_type: true,
                types: true,
            };

            filterDispatcher({
                type: 'SELECTED_FILTERS',
                payload: filterUrlParams
            });

            getCitiesItems(filterUrlParams);

            if (!isEmpty(setLoadServerSideTimeOut)) {
                clearTimeout(setLoadServerSideTimeOut);
            }

            setLoadServerSideTimeOut = setTimeout(() => {
                setLoadServerSide(false);
                delete urlParams['city_id'];
                delete urlParams['district_id'];
            }, 3000)
        }
    };

    const handleRedirectFilters = (checkRedirect) => {

        if (!isEmpty(checkRedirect.landing)) {
            //handlerKey = -1;
            getSearchLink(filters.selected_filters).then(result => {
                router.push('/properties', result.url + (isBadeSaba ? '?badesaba=true' : ''), {shallow: true});
            });

            handleTitle();
            scrollToTop();

            setShowLanding(checkRedirect.landing);
        } else {
            properties_dispatcher({
                type: 'PUSH_STATE',
                payload: {
                    link: checkRedirect.hrefAs,
                    href: checkRedirect.href,
                    loading: true,
                    back: false
                }
            })
        }
    };

    useEffect(() => {
        const bodyClassList = document.body.classList;
        const checkBodyClassLists = (!bodyClassList.contains('filter-open') && !bodyClassList.contains('selection-open') && !bodyClassList.contains('modal-open'));
        const routerQuery = router.query;

        if (checkBodyClassLists && !isEmpty(routerQuery) && typeof routerQuery === "object" && ObjectLength(routerQuery) && !isEmpty(routerQuery.category)) {

            if (routerQuery.category === 'my_properties' && categories !== 'my_properties') {
                setSkeleton(true);
                handleUserProperties();
            } else if (routerQuery.category === 'follow' && categories !== 'follow') {
                setSkeleton(true);
                handleBookmarkProperties();
            }

            setLoadServerSide(false);

            if (selectedFilters !== prevSelectedFilters) {
                let filterUrlParams = object_unique(urlParams);
                filterDispatcher({
                    type: 'SELECTED_FILTERS',
                    payload: filterUrlParams
                });
            }
        }
    }, [router.query]);

    useEffect(() => {
        if (process.browser) {
            history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        if (!isEmpty(urlParams['checkRedirectToLanding']) && urlParams['checkRedirectToLanding'].redirect) {
            setShowLanding(urlParams['checkRedirectToLanding'].landing)
        } else {
            setShowLanding('');
            setSkeleton(true);
        }

        if (!isEmpty(searchWidget) && !isEmpty(searchWidget['search_landing']) && searchWidget['search_landing']) {
            setSkeleton(true);

            urlParams['city_id'] = Number(urlParams['city_id']);

            handlePageWithUrlParams();

            handleTitle(searchWidget.widget);
        } else {

            if ((properties_context.pushState.offsetTop > 0 && properties_context.pushState.back) || properties_context.pushState.back) {

                const offsetTop = properties_context.pushState.offsetTop;

                properties_dispatcher({
                    type: 'PUSH_STATE',
                    payload: {
                        loading: false,
                        back: false,
                        offsetTop: 0
                    }
                });

                setTimeout(() => {
                    scrollToOffsetTop((offsetTop - 250), 0, false);
                }, 500);

                handleTitle();

                if (properties.length > 0) {
                    setSkeleton(false);
                } else if (!isEmpty(urlParams) && ObjectLength(urlParams)) {
                    handlePageWithUrlParams();
                } else {
                    setSkeleton(true);

                    const asPath = router.asPath;

                    checkUrlParams(asPath, linkTypes.SEARCH).then(result => {
                        urlParams = object_unique(mergeFiltersParams(result.query));
                        handlePageWithUrlParams();
                    }).catch(err => {
                        console.log(err)
                    });
                }
            } else {
                if (!isEmpty(urlParams) && typeof urlParams === "object" && (ObjectLength(urlParams) > 0)) {
                    handlePageWithUrlParams();
                } else if (ObjectLength(urlParams) < 1) {
                    getParamsFromLocationPath();
                }
            }
        }
    }, [urlParams]);

    var searchWidgetTimeOut = undefined;
    useEffect(() => {
        (async () => {
            const modalFiltersShow = document.body.classList.contains('filter-open');
            const filtersWaiting = filters.waiting;
            const checkWaiting = (!filtersWaiting.city && !filtersWaiting.district && !filtersWaiting.deal_type && !filtersWaiting.types && !modalFiltersShow);

            if (checkWaiting && !loadServerSide && !isEmpty(landingData)) {
                delete landingData['cityAreasWidget'];
                delete landingData['cityPropertiesWidget'];
                delete landingData['specialCities'];
                delete landingData['mostActiveRealtorsLists'];
            }

            if (!isEmpty(searchWidget) && !isEmpty(searchWidget['search_landing']) && searchWidget['search_landing']) {

                if (checkWaiting) {
                    if (isEmpty(ssrProperties)) {
                        handleGetProperties('ADD_NEW', true, true, true);
                    }

                    if (!isEmpty(searchWidgetTimeOut)) {
                        clearTimeout(searchWidgetTimeOut)
                    }

                    searchWidgetTimeOut = setTimeout(() => {
                        Object.keys(searchWidget).forEach(key => {
                            delete searchWidget[key]
                        })
                    }, 5000)
                }
            } else if (checkWaiting && (isEmpty(showLanding) || (!isEmpty(showLanding) && selectedFilters !== prevSelectedFilters)) && categories === 'search' && !modalFiltersShow) {
                if (!loadServerSide && selectedFilters !== prevSelectedFilters) {
                    const routerQuery = router.query;

                    if (checkWaiting && (isEmpty(routerQuery.category) || (routerQuery.category !== 'follow' && routerQuery.category !== 'my_properties'))) {
                        // check redirects
                        const checkRedirect = await checkFiltersForRedirect(filters.selected_filters, isBadeSaba);

                        if (checkRedirect.redirect) {
                            handleRedirectFilters(checkRedirect)
                        } else if (!properties_context.pushState.back) {
                            if (process.browser) {
                                scrollToTop();
                            }

                            setSkeleton(true);
                            setShowLanding('');

                            if (!isEmpty(getPropertiesTimeOut)) {
                                clearTimeout(getPropertiesTimeOut);
                            }

                            getPropertiesTimeOut = setTimeout(() => {
                                if ((!document.body.classList.contains('selection-open') && !document.body.classList.contains('filter-open'))) {
                                    handleGetProperties('ADD_NEW', true);
                                }
                            }, 500)
                        } else if (properties_context.pushState.back) {

                            properties_dispatcher({
                                type: 'PUSH_STATE',
                                payload: {
                                    loading: false,
                                    back: false,
                                    offsetTop: 0
                                }
                            });
                        }
                    } else {
                        setSkeleton(true);
                    }
                } else if (!loadServerSide) {
                    const checkRedirect = await checkFiltersForRedirect(filters.selected_filters, isBadeSaba);

                    if (checkRedirect.redirect) {
                        handleRedirectFilters(checkRedirect)
                    } else {
                        if (selectedFilters !== prevSelectedFilters) {
                            handleTitle();
                        }

                        if (categories === 'search') {
                            setSkeleton(false);
                            handleTitle();
                        }

                        if (!isEmpty(properties_context.list_page) && properties_context.list_page !== 'search') {
                            handleGetProperties('ADD_NEW', true);
                        }
                    }
                } else if (properties.length) {
                    if (!loadServerSide) {
                        handleTitle();
                    } else if (!isEmpty(redirectToLanding)) {
                        setShowLanding(redirectToLanding.landing)
                    }

                    setSkeleton(false);

                    if (!isEmpty(setLoadServerSideTimeOut)) {
                        clearTimeout(setLoadServerSideTimeOut);
                    }

                    setLoadServerSideTimeOut = setTimeout(() => {
                        setLoadServerSide(false);
                    }, 3000)
                }
            }

            handleUserModality(filters.selected_filters);

            checkRunInvestmentConversionsPopUp(filters.selected_filters, function () {
                handleUserModality(filters.selected_filters, true);
            });
        })()
    }, [filters]);


    useEffect(() => {
        const windowSize = window.innerWidth;
        if (!isEmpty(searchNavbarRef.current)) {
            if (windowSize > 991) {
                const handleScroll = (event) => {

                    if (window.pageYOffset > 82) {
                        searchNavbarRef.current.classList.add('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.add('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.add('search-navbar-fixed');
                        }
                    } else {
                        searchNavbarRef.current.classList.remove('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.remove('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                        }
                    }
                };

                window.addEventListener('scroll', handleScroll);
                return () => {
                    window.removeEventListener("scroll", handleScroll);
                };
            } else {
                searchNavbarRef.current.classList.remove('fixed-top');
                if (!isEmpty(cardRef.current)) {
                    cardRef.current.classList.remove('search-navbar-fixed');
                }

                if (!isEmpty(document.querySelector('.landing-page-container'))) {
                    document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                }
            }
        }
    });

    useEffect(() => {
        if (!isEmpty(properties_context.pushState)) {
            if (properties_context.pushState.loading && !properties_context.pushState.back) {
                router.push(properties_context.pushState.href, properties_context.pushState.link, {shallow: true});
            }
        }
    }, [properties_context]);


    useEffect(() => {
        if (userContext.check) {
            if (categories === 'my_properties' || !isEmpty(urlParams['categories[my_properties]'])) {
                setSkeleton(true);
                handleUserProperties();
            } else if (categories === 'follow' || !isEmpty(urlParams['follow'])) {
                setSkeleton(true);
                handleBookmarkProperties();
            }
        }
    }, [userContext]);

    const handleUserModality = ({city_id, district_id, deal_type}, isPopup = false) => {

        const data = {
            city_id: city_id,
            district_id: district_id,
            deal_type: deal_type
        };

        const check = checkUserModality(data);

        const appLayout = document.getElementById('appLayout');

        setTimeout(() => {
            const isPropertiesList = (appLayout.classList.contains('properties-lists'));
            const isLanding = (appLayout.classList.contains('is-landing'));

            check.page = (isPropertiesList && !isLanding) ? 'properties-list' : 'all';
            check.isBadeSaba = isBadeSaba;

            if (isPopup) {
                const checkIsGridView = checkGridView(((!isEmpty(urlParams['city_id']) && isServerSide) ? urlParams['city_id'] : (!isEmpty(selectedCity) ? selectedCity.id : urlParams['city_id'])));

                check['show_invest_modal'] = true;
                check['is_popup'] = true;
                check['event_section'] = 'properties';
                check['event_view'] = (checkIsGridView ? 'grid' : 'list');
                check['event_position'] = 'popup';
            }

            userDispatcherContext({
                type: 'MODALITY',
                payload: check,
            })
        }, 400)
    };

    const setInvestModalShow = () => {
        userDispatcherContext({
            type: 'MODALITY',
            payload: {
                type: userContext.modality.type,
                city_id: userContext.modality.city_id,
                city_name: userContext.modality.city_name,
                show_invest: userContext.modality.show_invest,
                show_invest_modal: true,
                isBadeSaba: isBadeSaba,
                event_section: 'properties',
                event_view: 'list-no-result',
            },
        })
    };

    const handleBackFromLanding = (ctx) => {
        const bodyClassList = document.body.classList;
        const checkBodyClassLists = (!bodyClassList.contains('filter-open') && !bodyClassList.contains('selection-open') && !bodyClassList.contains('modal-open'));

        if (checkBodyClassLists) {

            let {href, search} = document.location;
            const path = decodeURI(href);

            setShowLanding('');
            document.querySelector('.bullet-loading').classList.add('show-bullet-loading');

            const hasAmlak = path.indexOf('املاک-');
            if (hasAmlak !== -1) {
                checkUrlParams(href, linkTypes.SEARCH).then(result => {
                    urlParams = object_unique(mergeFiltersParams(result.query));

                    handlePageWithUrlParams();
                    document.querySelector('.bullet-loading').classList.remove('show-bullet-loading');
                }).catch(err => {
                    console.log(err)
                });
            } else if (!isEmpty(search)) {
                search = search.substring(1);
                urlParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

                handlePageWithUrlParams();

                document.querySelector('.bullet-loading').classList.remove('show-bullet-loading');
            }
        }
    };

    const cityId = (!isEmpty(urlParams['city_id']) && loadServerSide) ? urlParams['city_id'] : (!isEmpty(selectedCity) ? selectedCity.id : urlParams['city_id']);
    const propertyDealType = (!isEmpty(urlParams['deal_type']) && loadServerSide) ? urlParams['deal_type'] : (!isEmpty(filters) && !isEmpty(filters.selected_filters) ? filters.selected_filters.deal_type : '');
    const propertyType = (!isEmpty(urlParams['types']) && loadServerSide) ? urlParams['types'] : (!isEmpty(filters) && !isEmpty(filters.selected_filters) ? filters.selected_filters.types : '');

    const checkIsGridView = categories === 'search' && checkGridView(cityId);
    const checkShowHayaatBanner = false; //showHayaatBanner(cityId, selectedFiltersDistrictIds, propertyDealType, propertyType);

    return (
        <AppLayout
            page="properties"
            footerLinks={footerLinks}
            selectedCityId={cityId}
            propertyDealType={propertyDealType}
            pageRobots={pageRobots}
            pageCanonicalLink={pageCanonicalLink}
            pageTitle={title.pageTitle}
            pageDescription={title.pageDescription}
            ogDescription={title.pageDescription}
            footer={(!isBadeSaba)}
            investmentPageSection="properties"
            investmentPageView={(checkIsGridView ? 'grid' : 'list')}
            className={
                'properties-lists ' +
                (!isEmpty(showLanding) ? 'is-landing ' + showLanding : '') +
                ((forceShowNoResult || (isEmpty(showLanding) && !properties.length && !skeleton && !properties_context.pushState.back)) ? ' no-search-result-wrapper ' : '')
            }
        >

            {
                (!isEmpty(urlParams['breadcrumbList']) && urlParams['breadcrumbList'].length) ?
                    <BreadcrumbListSchema params={urlParams['breadcrumbList']}/> : ''
            }

            {
                (!isEmpty(ssrFaqsList) && ssrFaqsList.length) ?
                    <FaqSchema faqs={ssrFaqsList}/>
                    : ''
            }

            <PropertiesSchema properties={properties}/>

            <ContactInfoModal
                perContact={contactInfo}
                setPerContact={setContactInfo}
                setShowLoginWithCallback={handleLoginWithCallback}
            />

            <Container
                className={"search-properties " + (((!isEmpty(urlParams) && (!isEmpty(urlParams['categories[my_properties]']) || !isEmpty(urlParams['follow']))) || categories === 'my_properties' || categories === 'follow') ? 'my-properties' : '') + (showLanding === 'cities_home' ? ' pt-0 ' : '')}>

                <TopContainer className="top-container">

                    <Navbar
                        investmentEventSection="properties"
                        investmentEventView={(checkIsGridView ? 'grid' : 'list')}
                        navbarLinks={navbarLinks}
                        selectedCityId={(!isEmpty(urlParams['city_id']) ? urlParams['city_id'] : (!isEmpty(selectedCity) ? selectedCity.id : urlParams['city_id']))}
                        isBadeSaba={isBadeSaba}
                        showLoginModal={login.show}
                        setShowLoginModal={handleLoginWithCallback}
                        loginCallback={login.callback}
                        className={'properties-search-navbar ' + (showLanding === 'cities_home' ? 'cities-landing-navbar' : '')}
                    />

                    {
                        (showLanding !== 'cities_home' && categories === 'search' && (isEmpty(urlParams['categories[my_properties]']) && isEmpty(urlParams['follow']))) ?
                            <SearchFiltersAndModalFilters
                                searchNavbarRef={searchNavbarRef}
                                handleGetProperties={handleGetProperties}
                                handleRedirectFilters={handleRedirectFilters}
                                setShowLanding={setShowLanding}
                                showLanding={showLanding}
                                setSkeleton={setSkeleton}
                                isBadeSaba={isBadeSaba}
                            />
                            : ''
                    }

                </TopContainer>


                {
                    (!isEmpty(showLanding)) ?
                        <ShowSearchLandings
                            pageTitle={title.main}
                            showLanding={showLanding}
                            searchNavbarRef={searchNavbarRef}
                            landingData={landingData}
                            selectedCityId={(!isEmpty(urlParams['city_id']) ? urlParams['city_id'] : (!isEmpty(selectedCity) ? selectedCity.id : urlParams['city_id']))}
                            handleBackFromLanding={handleBackFromLanding}
                            setShowLanding={setShowLanding}
                            setSkeleton={setSkeleton}
                            isBadeSaba={isBadeSaba}
                            setContactInfo={setContactInfo}
                        />

                        :

                        <React.Fragment>
                            <Card ref={cardRef} className="container xs-fluid">

                                <SearchPageTitle
                                    searchTitle={title.main}
                                    skeleton={skeleton}
                                    isServerSide={loadServerSide}
                                    categories={categories}
                                    urlParams={urlParams}
                                    forceShowNoResult={forceShowNoResult}
                                    className="mx-24 mx-md-0"
                                />

                                {
                                    checkShowHayaatBanner ?
                                        <GridBanner
                                            className={"mx-24 mx-md-0 " + (skeleton ? 'grid-banner-has-skeleton' : 'mt-24')}>

                                        </GridBanner>
                                        :
                                        (
                                            checkIsGridView ?
                                                <>
                                                    <GridBanner
                                                        className={"mx-24 mx-md-0 mb-16 " + (skeleton ? 'grid-banner-has-skeleton' : 'mt-24')}>
                                                        {
                                                            (!isEmpty(filters.selected_filters) && !isEmpty(filters.selected_filters.deal_type)) ?
                                                                <InvestmentBannerGridWithLottie
                                                                    propertyTypes={filters.selected_filters.types}
                                                                    propertyDealType={filters.selected_filters.deal_type}
                                                                    districts={filters.selected_filters.district_id}
                                                                    city_id={(!isEmpty(selectedCity) ? selectedCity.id : urlParams['city_id'])}
                                                                    isBadeSaba={isBadeSaba}
                                                                />
                                                                : ''
                                                        }
                                                    </GridBanner>

                                                    <SearchTabsBox
                                                        className={"mx-24 mx-md-0 " + (skeleton ? 'has-skeleton' : '')}>
                                                        <SearchTabs
                                                            className={(checkIsGridView ? ' mb-8 border-transparent ' : '')}/>
                                                    </SearchTabsBox>
                                                </>
                                                :
                                                <SearchTabsBox
                                                    className={"mx-24 mx-md-0 " + (skeleton ? 'has-skeleton' : '')}>
                                                    <SearchTabs
                                                        className={(checkIsGridView ? ' mb-8 border-transparent ' : '')}/>
                                                </SearchTabsBox>
                                        )
                                }

                                <SearchPropertyCard
                                    properties={properties}
                                    authCheck={userContext.check}
                                    urlParams={urlParams}
                                    loadServerSide={loadServerSide}
                                    skeleton={skeleton}
                                    categories={categories}
                                    ssrHotLinks={ssrHotLinks}
                                    handleGetProperties={handleGetProperties}
                                    setContactInfo={setContactInfo}
                                    setForceShowNoResult={setForceShowNoResult}
                                    setSkeleton={setSkeleton}
                                    setLogin={setLogin}
                                    isBadeSaba={isBadeSaba}
                                    gridView={checkIsGridView}
                                    windowSize={windowSize}
                                />
                            </Card>

                            {
                                (forceShowNoResult || (!properties.length && !skeleton && !properties_context.pushState.back)) ?
                                    <SearchNoResults
                                        categories={categories}
                                        selectedCity={selectedCity}
                                        selectedFiltersDistrictIds={selectedFiltersDistrictIds}
                                        setInvestModalShow={setInvestModalShow}
                                        isBadeSaba={isBadeSaba}
                                    />
                                    : ''
                            }

                            <SearchFaqs
                                skeleton={skeleton}
                                ssrFaqsList={ssrFaqsList}
                                searchParams={loadServerSide ? urlParams : ((!isEmpty(filters) && !isEmpty(filters.selected_filters)) ? filters.selected_filters : [])}
                            />

                            <Sections className={"container mb-56"}>
                                <BrandingText
                                    skeleton={skeleton}
                                    content={ssrBrandingText}
                                    searchParams={loadServerSide ? urlParams : ((!isEmpty(filters) && !isEmpty(filters.selected_filters)) ? filters.selected_filters : [])}
                                />
                            </Sections>
                        </React.Fragment>
                }

            </Container>
        </AppLayout>
    )
}


Properties.getInitialProps = async (context) => {
    const {asPath, query, pathname, res, req} = context;
    let urlParams = JSON.parse(JSON.stringify(query));

    if (process.browser) {
        const url = process.env.NEXT_PUBLIC_APP_URL + decodeURI(asPath);
        const urlSearchParams = new URL(url);
        const badesaba = urlSearchParams.searchParams.get('badesaba');

        if (!isEmpty(badesaba)) {
            urlParams['badesaba'] = true;
        }
    }

    let searchWidget = null;
    let landingData = null;
    let searchWidgetUrl = null;
    let pageCanonicalLink = '/properties';
    let canEditPageCanonicalLink = true;
    let isServerSide = (!process.browser);
    let ssrProperties = null;
    let ssrFaqsList = null;
    let ssrBrandingText = null;

    if (asPath !== pathname) {
        const path = decodeURI(asPath);

        const hasAmlak = path.indexOf('املاک-');
        const hasCustomSearchLanding = path.indexOf('/c/');

        if (hasAmlak !== -1) {
            pageCanonicalLink = asPath;

            const checkUrl = await checkUrlParams(asPath, linkTypes.SEARCH);
            if (!isEmpty(checkUrl)) {
                let link = checkUrl.link;

                if (!isEmpty(link)) {
                    if (link.indexOf('?') !== -1) {
                        link = link.split('?')[0];
                    }

                    pageCanonicalLink = link;
                }

                if (!isEmpty(checkUrl.link) && checkUrl.redirect) {
                    const redirectStatusCode = checkUrl.redirect_status_code ?? 301;
                    const redirectLink = encodeURI(str_replace(process.env.NEXT_PUBLIC_APP_URL, '', checkUrl.link));

                    return Redirect(context, redirectLink, redirectStatusCode);
                }
                urlParams = {...urlParams, ...checkUrl.query};
            }
        } else if (hasCustomSearchLanding !== -1) {
            const hasParamPage = path.indexOf('page=');
            if (hasParamPage !== -1) {
                const redirectTo = removeURLParameter(path, 'page');

                const redirectLink = encodeURI(str_replace(process.env.NEXT_PUBLIC_APP_URL, '', redirectTo));
                return Redirect(context, redirectLink, 301);
            }

            // check custom link redirect
            const checkUrl = await checkUrlParams(asPath, linkTypes.SEARCH);
            if (!isEmpty(checkUrl.link) && checkUrl.redirect) {
                const redirectStatusCode = checkUrl.redirect_status_code ?? 301;
                const redirectLink = encodeURI(str_replace(process.env.NEXT_PUBLIC_APP_URL, '', checkUrl.link));

                return Redirect(context, redirectLink, redirectStatusCode);
            }

            let customPath = str_replace('/c', '', path).split('?');

            const param = {
                type: 'search_landing',
                url: encodeURI(customPath[0])
            };

            await getWidgets(param).then(result => {
                if (result && result.widgets && result.widgets.length) {
                    const widget = result.widgets[0];

                    if (!isEmpty(widget)) {
                        const widgetParams = JSON.parse(widget.params);
                        const params = getWidgetSearchParams(widget);

                        pageCanonicalLink = '/c' + encodeURI(widget.url);
                        canEditPageCanonicalLink = false;

                        searchWidget = {
                            search_landing: true,
                            widget: {
                                title: !isEmpty(widgetParams['title']) ? widgetParams.title : '',
                                caption: !isEmpty(widgetParams['caption']) ? widgetParams.caption : '',
                                label: !isEmpty(widgetParams['label']) ? widgetParams.label : '',
                            }
                        };

                        urlParams = params
                    }
                }
            })
        } else if (!ObjectLength(urlParams)) {
            //const checkUrl = await checkUrlParams(asPath, linkTypes.SEARCH);
            urlParams = getUrlParams(asPath);
            canEditPageCanonicalLink = false;
        }
    }

    if (!isEmpty(res) && isEmpty(urlParams.city_id)) {
        if (!isEmpty(req) && !isEmpty(req.cookies) && !isEmpty(req.cookies.default_city_id) && req.cookies.default_city_id !== 'undefined') {
            urlParams['city_id'] = req.cookies.default_city_id;
        } else {
            urlParams['city_id'] = 259;
        }
    }

    urlParams = object_unique(mergeFiltersParams(urlParams));

    const isBadeSaba = !isEmpty(urlParams['badesaba']);

    if (isServerSide && !isEmpty(urlParams['city_id']) && ObjectLength(urlParams) === 1) {
        const $url = '/' + await getCityURL(urlParams['city_id'], true);
        return Redirect(context, $url, 301);
    }

    const checkRedirectToLanding = await checkFiltersForRedirect(urlParams, isBadeSaba);

    urlParams['checkRedirectToLanding'] = checkRedirectToLanding;

    if (isServerSide && !checkRedirectToLanding.redirect && isEmpty(urlParams['follow']) && isEmpty(urlParams['my_properties'])) {
        const urlParamsCopy = JSON.parse(JSON.stringify(urlParams));

        const unsetParam = ['widget_city_id', 'widget_district_id', 'widget_type', 'badesaba',
            'page', 'section', 'max_items', 'url', 'position', 'content',
            'files', 'file', 'search_landing', 'caption', 'title', 'label', 'city_geo_text', 'city_name', 'checkRedirectToLanding'];

        for (let item of unsetParam) {
            delete urlParamsCopy[item]
        }

        urlParamsCopy['exclude_archived'] = 1;
        ssrProperties = await getProperties(1, '', urlParamsCopy, true);

        ssrFaqsList = await getSearchFaq(urlParamsCopy);
    } else if (isServerSide && checkRedirectToLanding.redirect) {
        landingData = await handleLandingsDataSsr(urlParams, checkRedirectToLanding);
    }

    if (isServerSide && !isBadeSaba && canEditPageCanonicalLink) {
        const getLandingCanonicalSearchWidget = await getCanonicalSearchWidget(urlParams);

        if (!isEmpty(getLandingCanonicalSearchWidget)) {
            pageCanonicalLink = '/c' + getLandingCanonicalSearchWidget.url;
        }
    }


    let pageTitles = null;
    if (isServerSide) {
        pageTitles = await generateSearchTitle(urlParams, asPath);

        if (!isEmpty(searchWidget)) {
            pageTitles.main = searchWidget.widget.caption;

            if (!isEmpty(searchWidget.widget.title)) {
                pageTitles.pageTitle = searchWidget.widget.title;
            }

            if (!isEmpty(searchWidget.widget.label)) {
                pageTitles.pageDescription = searchWidget.widget.label;
            }
        }

        urlParams['breadcrumbList'] = pageTitles.breadcrumbList;
    }

    setDefaultCity(urlParams['city_id'], context); // save default city in cookie

    let footerLinks = null;
    let navbarLinks = null;
    let ssrFilterOptionsByCity = null;

    if (!process.browser) {
        ssrFilterOptionsByCity = await getCitiesItemsFilterOptions(urlParams, isBadeSaba);

        footerLinks = await handleFooterLinks(urlParams['city_id'], urlParams['deal_type'], 'properties');
        navbarLinks = await handleNavbarLinks(urlParams['city_id']);

        ssrBrandingText = await getSearchBrandingText(urlParams);
    }

    // page canonical
    if (!isBadeSaba && canEditPageCanonicalLink) {
        const searchLink = await getSearchLink(urlParams, false, true);
        if (searchLink) {
            pageCanonicalLink = searchLink.url;
        }

        pageCanonicalLink = checkCanonicalLink(pageCanonicalLink);
    }

    let ssrHotLinks = '';

    if (isServerSide) {
        let selectedFiltersDistrictIds = [];
        if (!isEmpty(urlParams) && !isEmpty(urlParams['district_id'])) {
            selectedFiltersDistrictIds = urlParams['district_id'];
        }

        ssrHotLinks = await getSearchHotLinks(urlParams, selectedFiltersDistrictIds, isBadeSaba, asPath);
    }

    let pageRobots = await handlePageRobots(urlParams, searchWidgetUrl, isBadeSaba);
    if (urlParams.checkRedirectToLanding && !urlParams.checkRedirectToLanding.redirect && ssrProperties && ssrProperties.total < 1) {
        pageRobots = 'NOODP, nofollow, noindex';
    }


    return {
        navbarLinks: navbarLinks,
        footerLinks: footerLinks,
        urlParams: urlParams,
        ssrProperties: ssrProperties,
        ssrHotLinks: ssrHotLinks,
        searchWidget: searchWidget,
        landingData: landingData,
        pageRobots: pageRobots,
        pageTitles: pageTitles,
        pageCanonicalLink: pageCanonicalLink,
        redirectToLanding: checkRedirectToLanding,
        isServerSide: isServerSide,
        ssrFilterOptionsByCity: ssrFilterOptionsByCity,
        isBadeSaba: isBadeSaba,
        ssrFaqsList: ssrFaqsList,
        ssrBrandingText: ssrBrandingText,
    }
};

export default Properties;

// styles
const Container = styled.div`
  @media (max-width: ${props => props.theme.screenSmMax}) {
    padding-top: 115px;

    &.my-properties {
      padding-top: 56px;
    }
  }

  .cities-landing-navbar {
    position: absolute;
    top: 0;
    left: 0;

    &, & .navbar-card {
      background-color: transparent;
      border: none;
    }
  }
`;

const Card = styled.div`

  &.search-navbar-fixed {
    margin-top: 120px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 0;
    }
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    .row {
      margin-right: 0 !important;
      margin-left: 0 !important;

      [class*="col-"] {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }
  }
`;

const TopContainer = styled.div`
  @media (max-width: ${props => props.theme.screenSmMax}) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 110;
  }
`;

const SearchTabsBox = styled.div`

  &.has-skeleton {
    margin-top: 69px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 37px !important;
    }
  }

  &.no-sort {
    border-bottom: 1px solid ${props => props.theme.gray200};
  }
`;

const GridBanner = styled.div`

  &.grid-banner-has-skeleton {
    margin-top: 37px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 32px !important;
    }
  }
`;

const Sections = styled.section`
  margin-top: 80px;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 64px;
  }

  .content {
    h2, h3 {
      margin: 32px 0 16px;
    }
  }
`;